import { Typography } from '@mui/material';
import { ReactNode } from 'react';

import { EmptyPlaceholder } from './EmptyPlaceholder';
import EntityViewContentValueRow from './EntityViewContentValueRow';

interface EntityViewTextValueRowProps {
    text: string | undefined | null;
    icon?: ReactNode;
}

function EntityViewTextValueRow({ text, icon }: EntityViewTextValueRowProps) {
    return (
        <EntityViewContentValueRow icon={ icon } >
            <Typography variant="body2">
                { text || <EmptyPlaceholder /> }
            </Typography>
        </EntityViewContentValueRow>
    );
}

export default EntityViewTextValueRow;
